import React from 'react';
import { Container, Description, Number, Image } from './styled';

const ResultContainer = ({ number, description, color, fontSize, icon, iconWidth }) => {
    return (
        <Container>
            <Number color={color} fontSize={fontSize}>
                {number}
                {
                    icon ? (
                        <Image width={iconWidth} alt='' src={require(`../../assets/${icon}`)} />
                    ) : null
                }
            </Number>
            <Description>
                {description}
            </Description>
        </Container>
    );
};

export default ResultContainer;
